import { COUNTRIES_ISO_3, REGIONS } from '../constants';
import { microservices } from '../constants/microservices';
import { EnvironmentTypes } from '../types/domain';
/**
 * Checks if the current environment is rendered by client-side
 */
export const isCSR = () => typeof window !== 'undefined';
export const getDomain = () => {
    const domainParts = window === null || window === void 0 ? void 0 : window.location.host.split('.');
    domainParts.shift();
    /**
     * Set the 'domain' attribute of the cookie to e.g. ".weltsparen.de",
     * so it is also accessible on Public Website
     *
     * or
     *
     * set it to whatever the domain is, if on localhost
     */
    return domainParts.length <= 1 ? '' : `.${domainParts.join('.')}`;
};
export const getLocale = () => {
    var _a;
    if (isCSR()) {
        const { host, pathname } = window.location;
        if (host.endsWith('.de') || host.endsWith('.at'))
            return 'de';
        if (host.endsWith('.co.uk') || host.endsWith('.ie'))
            return 'en';
        if (host.endsWith('.com')) {
            const localePrefix = (_a = pathname.split('/')[1]) !== null && _a !== void 0 ? _a : '';
            switch (localePrefix.toLowerCase()) {
                case 'pl-pl':
                    return 'pl';
                case 'fi-fi':
                    return 'fi';
                case 'fr-fr':
                    return 'fr';
                case 'de-de':
                case 'de-at':
                    return 'de';
                case 'es-es':
                    return 'es';
                case 'nl-nl':
                    return 'nl';
                case 'en-gb':
                case 'en-ie':
                default:
                    return 'en';
            }
        }
        if (host.endsWith('.es'))
            return 'es';
        if (host.endsWith('.fr'))
            return 'fr';
        if (host.endsWith('.nl'))
            return 'nl';
    }
    return 'de';
};
export const getNamespaceName = () => {
    if (isCSR()) {
        const name = /bk-(deu|gbr)-(.*)\.raisin-dev\.network/.exec(window.location.host);
        return name ? name[2] : EnvironmentTypes.DEVELOPMENT;
    }
    return EnvironmentTypes.DEVELOPMENT;
};
export const getRegionFromHost = () => {
    var _a, _b;
    return isCSR() && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) === null || _b === void 0 ? void 0 : _b.endsWith('.co.uk'))
        ? COUNTRIES_ISO_3.GBR
        : COUNTRIES_ISO_3.DEU;
};
export const checkHost = (host) => { var _a; return isCSR() && ((_a = window.location.host) === null || _a === void 0 ? void 0 : _a.includes(host)); };
export const getEnvironment = () => {
    if (checkHost(EnvironmentTypes.STAGING))
        return EnvironmentTypes.STAGING;
    if (checkHost(EnvironmentTypes.ONBOARDING))
        return EnvironmentTypes.ONBOARDING;
    if (checkHost(EnvironmentTypes.PRODUCTION))
        return EnvironmentTypes.PRODUCTION;
    if (checkHost(EnvironmentTypes.AMPLIFY_APP))
        return EnvironmentTypes.DEVELOPMENT;
    if (checkHost('raisin-dev.network'))
        return getNamespaceName();
    if (checkHost('localhost'))
        return EnvironmentTypes.LOCAL;
    return EnvironmentTypes.PRODUCTION;
};
export const isLocalEnv = () => getEnvironment() === EnvironmentTypes.LOCAL;
export const getUnixTime = (buffer = 0) => Math.round(Date.now() / 1000 + buffer);
export const DEVELOPMENT_ENV_DOMAIN_REGION_REGEX = /bk-(deu|gbr)-(.*)\.raisin-dev\.network/;
export const getRegionName = () => {
    var _a;
    const hostname = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname;
    const developmentName = DEVELOPMENT_ENV_DOMAIN_REGION_REGEX.exec(hostname);
    if (developmentName) {
        return developmentName[1].toUpperCase();
    }
    return (hostname === null || hostname === void 0 ? void 0 : hostname.endsWith('.co.uk')) ? REGIONS.GBR : REGIONS.DEU;
};
export const getMicroServiceBaseUrl = (microserviceName) => {
    var _a;
    const environment = getEnvironment();
    const region = getRegionName();
    if ((_a = microservices === null || microservices === void 0 ? void 0 : microservices[microserviceName]) === null || _a === void 0 ? void 0 : _a[region]) {
        return microservices[microserviceName][region][environment];
    }
    return microservices[microserviceName][environment];
};
//# sourceMappingURL=env.js.map